export const Colors = {
  // Gradient backgrounds
  bgTop: '#D8EAE0',
  bgMid: '#B5CFC4',
  bgBot: '#5B8BA0',
  splashTop: '#C8DDD5',
  splashBot: '#1E6080',

  // Primary palette
  primary: '#3A7CA5',
  primaryLight: '#5A9CBF',
  primaryDark: '#2A6085',

  // Accent
  accent: '#E8A838',
  accentLight: '#F0CC60',

  // Coral / warm
  coral: '#D4845A',
  coralDark: '#C07040',

  // Greens
  green: '#4CAF50',
  greenLight: '#C8F0CA',

  // Navigation bar
  navBar: '#2B6683',
  navBarDark: '#1E4F66',

  // Text
  textDark: '#1A2E35',
  textMid: '#4A6670',
  textLight: '#7A9AA5',

  // Cards & surfaces
  card: 'rgba(255,255,255,0.72)',
  cardSolid: '#F0F5F2',
  white: '#FFFFFF',
  border: 'rgba(0,0,0,0.08)',

  // Status
  danger: '#E05555',

  // Screen time rewards
  screenTime: '#6C5CE7',
  screenTimeLight: '#A29BFE',

  // Overlay
  overlayDark: 'rgba(10,20,30,0.93)',

  // Task type colors
  medication: '#E07070',
  selfCare: '#60B0D0',
  wellness: '#7BC67E',

  // Spinner pin
  pinBlue: '#2878A4',
  pinPurple: '#5B4FCF',
};

export const Gradients = {
  background: [Colors.bgTop, Colors.bgMid, Colors.bgBot],
  splash: [Colors.splashTop, '#6AA0B8', Colors.splashBot],
  navBar: [Colors.navBar, Colors.navBarDark],
  pledge: ['#F5E6C8', '#E8DDD0', '#D8E8E0'],
  coralButton: [Colors.coral, Colors.coralDark],
  primaryButton: [Colors.primary, '#2A6A90'],
  goldButton: ['#E8C070', '#D4A050'],
};
